import request from '@/http/request'

export const getCscSummaryReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/csc/report/summary`, params)
}

export const getCscSummaryDropDown = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/csc/report/findDropDown`, { params })
}

export const exportSummaryReportDownload = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/csc/report/exportSummary`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
